import * as React from "react";
import { H2 } from "@grandvisionhq/iris-ui";
import { RecommendationsGallery } from "../../../../../RecommendationsGallery/lib-components/RecommendedProducts/components/RecommendationsGallery/RecommendationsGallery.js";
/* empty css                                           */
const RecommendationsGalleryMiniCartSection = ({
  recommendations,
  title
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: "recommendations-gallery-mini-cart-section" }, /* @__PURE__ */ React.createElement(H2, { className: "recommendations-gallery-mini-cart-section__heading", variant: "smallest" }, title), /* @__PURE__ */ React.createElement(
    RecommendationsGallery,
    {
      recommendations,
      itemsPerSlide: 4,
      shouldRenderBlocksAsCards: true,
      navigationLocation: "top"
    }
  ));
};
export {
  RecommendationsGalleryMiniCartSection
};
//# sourceMappingURL=RecommendationsGalleryMiniCartSection.js.map
